<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path
    d="M14.1663 7.91602L9.99967 12.0827L5.83301 7.91602"
    [attr.stroke]="'var(' + color + ')'"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
